import { motion } from 'framer-motion'

export function RepositoryIntelligence() {
  return (
    <section className="py-24 sm:py-32 border-t border-line bg-surface relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-primary/5 to-transparent opacity-50" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl font-semibold text-ink tracking-tight">
              Your GitHub, understood.
            </h2>
            <p className="mt-6 text-lg text-ink-muted leading-relaxed">
              Ask questions about repositories, issues, pull requests and changes without manually searching through every file. RepoPilot connects the dots across your entire codebase context instantly.
            </p>
          </div>
          
          <div className="relative">
            {/* Glass Reveal Depth Card */}
            <div className="rounded-xl border border-line bg-ground/80 backdrop-blur-md p-6 shadow-pop overflow-hidden select-none">
              <div className="flex flex-col gap-6 font-mono text-xs sm:text-sm">
                
                {/* User Message */}
                <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="flex justify-end">
                  <div className="bg-raised border border-line rounded-lg rounded-tr-none px-4 py-3 text-ink max-w-[80%] shadow-card">
                    What changed in the authentication system this week?
                  </div>
                </motion.div>

                {/* AI Response */}
                <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ delay: 0.4 }} viewport={{ once: true }} className="flex justify-start">
                  <div className="bg-surface border border-line rounded-lg rounded-tl-none px-4 py-4 text-ink-muted max-w-[90%] shadow-card">
                    <div className="flex items-center gap-2 mb-3 text-primary text-xs font-semibold tracking-wider">
                      <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                      ANALYZING
                    </div>
                    
                    <div className="grid grid-cols-3 gap-2 mb-4 border-b border-line pb-4">
                      <div className="flex flex-col"><span className="text-ok font-semibold">42</span><span>commits</span></div>
                      <div className="flex flex-col"><span className="text-ok font-semibold">7</span><span>pull requests</span></div>
                      <div className="flex flex-col"><span className="text-ok font-semibold">3</span><span>issues</span></div>
                    </div>

                    <div className="text-ink font-semibold mb-2">Summary</div>
                    <div className="leading-relaxed">
                      Authentication middleware was updated to enforce stricter token validation. The legacy OAuth flow has been fully deprecated in PR #284.
                    </div>
                  </div>
                </motion.div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
